var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"病虫害防治","visible":_vm.show,"width":"60%"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('div',{staticStyle:{"height":"360px"}},[_c('el-alert',{attrs:{"type":"success","closable":false}},[_vm._v("\n      病虫害防治请使用配套手机端进行识别和获取防治指导。\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b194ad8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome/LandGuideDiseaseDialog.vue
// module id = null
// module chunks = 